import React, { useState, useRef, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { If } from "react-condition";
import { v4 as uuidv4 } from "uuid";
function TextTable({ onMoveDown, onMoveUp, onElementDelete, preset }) {
  // States
  const [element, setElement] = useState({
    id:uuidv4(),
    type: "texttable",
    properties: {
      label: "Text Table question field.",
      options: [],
      rows: 3,
      addMore: false,
    },
    required: false,
    fillableByCandidate: true,
    fillableByHR: false,
  });

  const [options, setOptions] = useState([]);

  const [modal, setModal] = useState(false);

  // Refs
  const elementLabelRef = useRef();
  const fillableCandidateRef = useRef();
  const fillableHRRef = useRef();
  const elementLengthRef = useRef();
  const elementAddMoreRef = useRef();
  const elementAnswerRef = useRef();

  // Effects
  useEffect(() => {
    if (preset !== null && preset !== {} && preset !== undefined) {
      setElement((previousState) => {
        return { ...previousState, ...preset };
      });
      setOptions(preset.properties.options);
    }
  }, [preset]);

  // Events
  const toggle = () => setModal(!modal);

  function onEdit() {
    setElement((previousState) => {
      if (elementLabelRef.current.value !== "") previousState.properties.label = elementLabelRef.current.value;
      previousState.properties.options = options;
      if (elementLengthRef.current.value !== "") previousState.properties.rows = elementLengthRef.current.value;
      previousState.properties.addMore = elementAddMoreRef.current.checked;
      previousState.fillableByCandidate = fillableCandidateRef.current.checked;
      previousState.fillableByHR = fillableHRRef.current.checked;
      return previousState;
    });
    toggle();
  }

  function onAddNewAnswer(event) {
    setOptions((state) => {
      state = [...state, elementAnswerRef.current.value];
      elementAnswerRef.current.value = "";
      return state;
    });
  }

  function onDeleteOption(event) {
    const value = event.target.getAttribute("v");
    setOptions((state) => {
      let newState = [];
      for (let index = 0; index < state.length; index++) {
        const element = state[index];
        if (element !== value) {
          newState.push(element);
        }
      }
      return newState;
    });
  }

  return (
    <div className="form-group mb-3 form-builder-element" data={JSON.stringify(element)}>
      <button className="btn btn-danger btn-circle btn-sm mr-2 btn-builder-right" onClick={onElementDelete}>
        <i className="fa fa-trash"></i>
      </button>
      <button className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right" onClick={toggle}>
        <i className="fa fa-asterisk"></i>
      </button>
      <button className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right" onClick={onMoveUp}>
        <i className="fa fa-chevron-up"></i>
      </button>
      <button className="btn btn-primary btn-circle btn-sm mr-2 btn-builder-right" onClick={onMoveDown}>
        <i className="fa fa-chevron-down"></i>
      </button>
      <label htmlFor="">
        {element.properties.label}
        {element.required && <span style={{color:'red'}}>*</span>}
      </label>
      <table className="table table-striped">
        <thead>
          <tr>
            {options.map((v, k) => (
              <th key={k}>{v}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from(Array(parseInt(element.properties.rows)).keys()).map((v, k) => (
            <tr key={k}>
              {options.map((v1, k1) => (
                <td key={k1}>
                  <input type="text" className="form-control" />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <If test={element.properties.addMore}>
        <div style={{ height: "40px" }}>
          <button className="btn btn-link float-right">Add More</button>
        </div>
      </If>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Edit Text Table Properties</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>Label</label>
            <input ref={elementLabelRef} defaultValue={element.properties.label} type="text" className="form-control" />
          </div>
          <div className="form-group">
            <label>Text Field Label</label>
            {options.map((v, k) => (
              <div className="mb-3" key={k}>
                {k + 1}. {v}{" "}
                <button className="btn btn-sm btn-danger float-right" v={v} onClick={onDeleteOption}>
                  Delete
                </button>
              </div>
            ))}
          </div>
          <div className="form-group">
            <div className="input-group">
              <input ref={elementAnswerRef} type="text" className="form-control" />
              <div className="input-group-append">
                <button className="btn btn-primary" onClick={onAddNewAnswer}>
                  Add
                </button>
              </div>
            </div>
          </div>
          <div className="form-group">
            <label>Number of Rows</label>
            <input ref={elementLengthRef} type="text" className="form-control" />
          </div>
          <div className="custom-control custom-checkbox">
            <input type="checkbox" ref={elementAddMoreRef} className="custom-control-input" id="canAddMoreCheck" />
            <label className="custom-control-label" htmlFor="canAddMoreCheck">
              Can Add More?
            </label>
          </div>
          <div className="custom-control custom-checkbox formbuilder-hidden">
            <input
              type="checkbox"
              ref={fillableCandidateRef}
              className="custom-control-input"
              id="fillableCandidate"
              defaultChecked={element.fillableByCandidate}
            />
            <label className="custom-control-label" htmlFor="fillableCandidate">
              Can candidates edit this field?
            </label>
          </div>

          <div className="custom-control custom-checkbox formbuilder-hidden">
            <input
              type="checkbox"
              ref={fillableHRRef}
              className="custom-control-input"
              id="fillableHR"
              defaultChecked={element.fillableByHR}
            />
            <label className="custom-control-label" htmlFor="fillableHR">
              Can HRs edit this field?
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onEdit}>
            Update
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default TextTable;
